module.exports = __webpack_public_path__ + "img/application4.95d9e946.png";